
export const environment = {
  production: false,
  SERVER_API_URL: 'https://api.fma.dev.techland.link/admin/',
  urlUploadBackEnd : 'https://upload.dev.techland.link',
  KEY_TOKEN: 'token',
  MAX_FILE_SIZE: 5 * 1024 * 1024,
  MAX_QUEUE_LIMIT: 5
};